export default __webpack_public_path__ + "static/media/check-green.04b389d7.svg";